import { render, staticRenderFns } from "./UserAddedToDepartment.vue?vue&type=template&id=daa7cba6&scoped=true"
import script from "./UserAddedToDepartment.vue?vue&type=script&lang=js"
export * from "./UserAddedToDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa7cba6",
  null
  
)

export default component.exports